import React, { useState, useEffect, useRef } from "react";
import Tree from "react-d3-tree";
import styles from "./TreeViewer.module.css";
import { NodeModal } from "../../molecules/NodeModal/NodeModal";
import { Label } from "../../atoms/Label/Label";

interface TreeViewerProps {
  data: any;
  orientation?: "vertical" | "horizontal";
  pathFunc?: "diagonal" | "elbow" | "straight" | "step";
  translate?: { x: number; y: number };
}

export const TreeViewer: React.FC<TreeViewerProps> = ({
  data,
  orientation = "vertical",
  pathFunc = "diagonal",
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [translate, setTranslate] = useState({ x: 0, y: 0 });
  const [selectedNode, setSelectedNode] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      const { width } = containerRef.current.getBoundingClientRect();
      setTranslate({ x: width / 2, y: 50 });
    }
  }, []);

  const handleNodeClick = (nodeDatum: any) => {
    setSelectedNode(nodeDatum);
    setIsModalOpen(true);
  };

  const renderForeignObjectNode = ({ nodeDatum, toggleNode }: any) => (
    <g>
      <foreignObject width={220} height={120} x={-110} y={-50}>
        <div
          className={`${styles.nodeCard} ${
            nodeDatum.children ? styles.branchNode : styles.leafNode
          } ${!nodeDatum.parent ? styles.rootNode : ""}`}
          onClick={() => handleNodeClick(nodeDatum)}
        >
          <div className={styles.nodeHeader}>{nodeDatum.name}</div>
          {nodeDatum.attributes && (
            <div className={styles.nodeSub}>
              {Object.entries(nodeDatum.attributes).map(([key, value]) => (
                <div key={key}>
                  {key}: {value as string}
                </div>
              ))}
            </div>
          )}
          {nodeDatum.children && (
            <button
              className={styles.expandButton}
              onClick={(e) => {
                e.stopPropagation();
                toggleNode();
              }}
            >
              {nodeDatum.__rd3t.collapsed ? "Expandir" : "Contraer"}
            </button>
          )}
        </div>
      </foreignObject>
    </g>
  );

  return (
    <>
      <div id="treeWrapper" className={styles.treeWrapper} ref={containerRef}>
        <Tree
          data={data}
          orientation={orientation}
          pathFunc={pathFunc}
          translate={translate}
          renderCustomNodeElement={renderForeignObjectNode}
          nodeSize={{ x: 250, y: 150 }}
        />

        <NodeModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          data={selectedNode}
        />
      </div>
      <Label>
        <div className="flex gap-4 justify-center items-center bg-white p-2 rounded-lg font-bold text-gray-500">
          Total de registros: <span className="text-white w-20 bg-gray-400 rounded-lg p-3 text-center">{data.totalRecords}</span>
        </div>
      </Label>
    </>
  );
};
